import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import avatar from "../../assets/images/avatar.svg";
import { ProfileSection } from "../../context/ProfileContext";
import { setInvitedUser, setInvitedUserSetting } from "../../redux";
import { dashboardMine, invitationAuthorityGet } from "../../api";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UsersComp = (props) => {
  const { t } = useTranslation();
  const { user } = props;
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardDetails = useSelector((state) => state.dashboardDetails);
  const userDetail = () => {
    dispatch(setInvitedUser(user));
    const data = new FormData();
    data.append("invitation", user.id);
    data.append("dashboard", dashboardDetails.id);
    invitationAuthorityGet(data, token)
      .then((res) => {
        dispatch(setInvitedUserSetting(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });

    setTimeout(() => {
      ProfileShowHideFunc("usersSetting");
    }, 1000);
  };

  return (
    <div
      className="profileUsers cursor bg-white d-flex align-items-center justify-content-around py-2 mb-2"
      onClick={userDetail}
    >
      <img src={avatar} width="35" height="35" className="rounded-circle" />
      <div className="text-right">
        <p className="m-0 fn12">{user.name}</p>
        <small className="fn10">{user.email}</small>
      </div>
      {/* <div className="profileUsersStatus d-flex align-items-center">
                <i className="profileUsersStatusIcon icon-ok text-white text-center d-block mx-1"></i>
                <small className="text-white text-right fn10">دسترسی کامل</small>
            </div> */}
      <div
        className={`addUserStatus ${
          user.registered ? "bg-accept" : "bg-invite"
        } d-flex align-items-center justify-content-center`}
      >
        <small className="text-white fn10">
          {user.registered ? t("قبول") : t("دعوت")}
        </small>
      </div>
    </div>
  );
};

const Users = withRouter(UsersComp);

export { Users };
